'use strict';

var Papa = require('papaparse');

var defaultCSVOptions = {
  header: true,
  dynamicTyping: true,
  skipEmptyLines: true,
  onStep: function onStep() /* current, total*/{
    // empty function
  }
};

/**
 * Create a new DB from a CSV file
 * @memberof DB
 * @param {text} csv - text file containing the comma separated value file
 * @param {object} [options={}]
 * @param {boolean} [options.header=true]
 * @param {boolean} [options.dynamicTyping=true]
 * @param {boolean} [options.skipEmptyLines=true]
 * @param {boolean} [computeProperties=false]
 * @param {function} [options.onStep=()=>{}] call back to execute after each molecule
 * @returns {DB}
 */

function parseCSV(csv) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var getMoleculeCreators = require('./moleculeCreators');
  var moleculeCreators = getMoleculeCreators(this.OCL.Molecule);

  if (typeof csv !== 'string') {
    throw new TypeError('csv must be a string');
  }
  options = Object.assign({}, defaultCSVOptions, options);

  var db = new this.MoleculeDB(options);
  return new Promise(function (resolve, reject) {
    var parsed = Papa.parse(csv, options);
    var fields = parsed.meta.fields;
    var stats = new Array(fields.length);
    var firstElement = parsed.data[0];
    var moleculeCreator = void 0,
        moleculeField = void 0;
    for (var _i = 0; _i < fields.length; _i++) {
      stats[_i] = {
        label: fields[_i],
        isNumeric: typeof firstElement[fields[_i]] === 'number'
      };
      var lowerField = fields[_i].toLowerCase();
      if (moleculeCreators.has(lowerField)) {
        moleculeCreator = moleculeCreators.get(lowerField);
        moleculeField = fields[_i];
      }
    }
    if (!moleculeCreator) {
      throw new Error('this document does not contain any molecule field');
    }
    db.statistics = stats;

    var i = 0;
    var l = parsed.data.length;
    parseNext();
    function parseNext() {
      if (i === l) {
        resolve(db);
        return;
      }
      try {
        db.pushEntry(moleculeCreator(parsed.data[i][moleculeField]), parsed.data[i]);
      } catch (e) {
        reject(e);
        return;
      }
      options.onStep(++i, l);
      setImmediate(parseNext);
    }
  });
}

module.exports = parseCSV;